import { ViewerForm } from "../services/hubspot";
import routes, { gotoPath } from "../routes";

const actionForm = form => ViewerForm.submit(form).then(gotoPath(routes.snapgeneViewerDownload));

export default actionForm;
